var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-plus-circle.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.7915 16.0417H25.2082V25.2084H16.0415V29.7917H25.2082V38.9584H29.7915V29.7917H38.9582V25.2084H29.7915V16.0417Z",
    fill: "#00B45E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.5002 4.58331C14.8639 4.58331 4.5835 14.8637 4.5835 27.5C4.5835 40.1362 14.8639 50.4166 27.5002 50.4166C40.1364 50.4166 50.4168 40.1362 50.4168 27.5C50.4168 14.8637 40.1364 4.58331 27.5002 4.58331ZM27.5002 45.8333C17.3916 45.8333 9.16683 37.6085 9.16683 27.5C9.16683 17.3914 17.3916 9.16665 27.5002 9.16665C37.6087 9.16665 45.8335 17.3914 45.8335 27.5C45.8335 37.6085 37.6087 45.8333 27.5002 45.8333Z",
    fill: "#00B45E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxPlusCircle);
export default __webpack_public_path__ + "static/media/bx-plus-circle.4ee04ce360b8212be9ed8948864d823d.svg";
export { ForwardRef as ReactComponent };